import { render, staticRenderFns } from "./LeaveTypeEdit.vue?vue&type=template&id=5baf7c47"
import script from "../../controllers/leave_type/leave-type-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/leave_type/leave-type-edit.js?vue&type=script&lang=js&external"
import style0 from "./LeaveTypeEdit.vue?vue&type=style&index=0&id=5baf7c47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports